import PropTypes from 'prop-types';
import React from 'react';

import Clickable from '../framework/clickable';
import GroupLink from '../framework/group_link';

const ProductItemTitle = ({
	groups,
	page,
	product_default,
	product_id,
	product_variant_id,
	slug,
	title,
}) => {
	const id_key = `product-item-${product_variant_id}-${slug}`;

	return (
		<Clickable id={id_key}>
			<GroupLink
				className="clickable text-decoration-none  btn bg-blue-600 border-0 bg
				btn-dark border-opacity-dark rounded-2 btn-sm xs mb-0"
				groups={
					product_default?.group_id ? [product_default?.group_id] : groups
				}
				page={page}
				product_id={product_id}
			>
				{title?.replace(/^MR\s+/i, '')}
			</GroupLink>
		</Clickable>
	);
};

ProductItemTitle.propTypes = {
	currency: PropTypes.object,
	excerpt: PropTypes.string,
	group_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	groups: PropTypes.array,
	markers: PropTypes.array,
	onAddToCart: PropTypes.func,
	page: PropTypes.string,
	price: PropTypes.string,
	price_discount: PropTypes.string,
	product_default: PropTypes.string,
	product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	product_image: PropTypes.object,
	product_variant_id: PropTypes.number,
	slug: PropTypes.string,
	state: PropTypes.string,
	status: PropTypes.string,
	subtitle: PropTypes.string,
	title: PropTypes.string,
	tracking: PropTypes.object,
	type: PropTypes.string,
};

export default ProductItemTitle;
